module.exports = __webpack_public_path__ + "img/new_phone_cover.cdebf016.png";